import React from "react";
import { FiSearch } from "react-icons/fi"; // search icon
import { Button, Col, Container, Input, InputGroup, Row } from "reactstrap";
import './Supporttickets.css'
import Previous_support_card from "./Previous_support_card";

function Previous_Support_Tickets() {
  return (
    <>
      <Container fluid className="">
        <Row className="align-items-center">
          {/* Heading */}
          <Col
            style={{ padding: "50px 0px" }}
            xs="12"
            md="6"
            className="mb-2 mb-md-0 "
          >
            <h1 style={{ fontSize: "24px", fontWeight: 700 }}>
              Previous Support Tickets
            </h1>
          </Col>

          {/* Search bar */}
          <Col
            xs="12"
            md="6"
            className="d-flex justify-content-md-end justify-content-start"
          >
            <InputGroup
              style={{
                width: "100%",
                maxWidth: "320px",
                border: "1px solid #DFDFDF",
                borderRadius: "8px",
                overflow: "hidden",
                height: "40px",
              }}
            >
              <Input
                placeholder="Search ticket here..."
                style={{
                  border: "none",
                  outline: "none",
                  padding: "0 12px",
                  fontSize: "14px",
                }}
              />

              <Button className="stbtn"
                style={{
                  height: "100%",
                  width: "46px",
                 
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  backgroundColor: "white",
                  border: "1px solid #E5E5E5",
                  
                }}
              >
                <FiSearch style={{ fontSize: "14px", color: "#B7B7B7 " }} />
              </Button>
            </InputGroup>
          </Col>
        </Row>

        {/* Tabs for Pending, In-Process, Resolved */}
       
<div className="tabs">
  <div className="tab-item active">Pending</div>
  <div className="tab-item">In‑Process</div>
  <div className="tab-item">Resolved</div>
</div>


        <Row style={{padding:"30px 0px"}}>
            <Col sm={12} xxl={4} xl={6}>
            <Previous_support_card />
            
            </Col>
            <Col sd={12} xxl={4}  xl={6}>

            <Previous_support_card />
            
            </Col >
             <Col sd={12} xxl={4} xl={6}>

            <Previous_support_card />
            
            </Col>
              
            
        </Row>

        

        
      </Container>
    </>
  );
}

export default Previous_Support_Tickets;
